import { useState } from 'react';
import api from '../api/api';

/**
 * Encapsula el import/export de catálogo a Excel. Se extrajo de Catalogo.js
 * porque no tiene relación con la carga/edición de la tabla: es un
 * subsistema aparte que se puede tocar (o reutilizar en otra pantalla)
 * sin arriesgar el resto del componente.
 *
 * @param {object} params
 * @param {number|string} params.userIdPet
 * @param {number|string} params.userIdUsuario
 * @param {(mensaje: string) => void} params.onNotify - snackbar de éxito/estado
 * @param {(mensaje: string) => void} params.onError - snackbar/estado de error
 */
export function useCatalogoExcel({ userIdPet, userIdUsuario, onNotify, onError }) {
  const [importing, setImporting] = useState(false);

  const handleExportExcel = async () => {
    try {
      const response = await api.get('/catalogos/excel/exportar', {
        params: { id_pet: userIdPet },
        responseType: 'blob', // Importante para recibir archivo binario
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Catalogo_Productos_${new Date().toISOString().slice(0, 10)}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      onNotify?.('Catálogo exportado a Excel exitosamente');
    } catch (err) {
      console.error('Error al exportar Excel:', err);
      onError?.('Error al exportar catálogo a Excel');
    }
  };

  const handleImportExcel = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setImporting(true);
      const response = await api.post(
        `/catalogos/excel/importar?id_pet=${userIdPet}&id_usuario=${userIdUsuario}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      const { procesados, creados, actualizados, errores } = response.data;
      let msg = `Procesados: ${procesados} | Creados: ${creados} | Actualizados: ${actualizados}`;

      if (errores && errores.length > 0) {
        msg += ` | Advertencias/Errores: ${errores.length}`;
        console.warn('Errores en importación:', errores);
      }

      onNotify?.(msg);

      // Recargar la tabla (misma conducta que antes de la separación)
      window.location.reload();
    } catch (err) {
      console.error('Error al importar Excel:', err);
      onError?.('Error al importar archivo Excel: ' + (err.response?.data?.detail || err.message));
    } finally {
      setImporting(false);
      event.target.value = ''; // Limpiar el input
    }
  };

  return { importing, handleExportExcel, handleImportExcel };
}
